export const getPeopleCount = (minPeopleCount: number, maxPeopleCount: number): string => {
	const isSamePeopleCount = minPeopleCount === maxPeopleCount
	const peopleCount = isSamePeopleCount ? `${maxPeopleCount}` : `${maxPeopleCount}`

	return peopleCount
}

export const getDateRange = (startDate: string, endDate: string): number => {
	if (!startDate || !endDate) return 0
	if (startDate === endDate) return 1

	const _startDate = new Date(startDate)
	const _endDate = new Date(endDate)
	const difference = _endDate.getTime() - _startDate.getTime()
	const totalDiffDays = Math.ceil((difference + 1) / (1000 * 3600 * 24))

	return totalDiffDays
}
